import React, { Component } from "react"
import { Form } from "app/forms/form"
import * as Elements from "app/forms/elements"

import thumbnail from "app/forms/images/templates/grove.jpg"

class Grove extends Component {
  static displayName = "Grove"
  static style = "form"
  static formats = ["sticky bar"]
  static thumbnail = thumbnail
  static fields = [
    {
      name: "first_name",
      label: "Your first name"
    },
    {
      name: "email_address",
      label: "Your email address"
    }
  ]

  render() {
    const { styles, elements, ...props } = this.props
    const contentColor = styles.forElement("content").color
    const customFieldCount = elements.custom.length
    const stackedDisplay = customFieldCount > 1

    return (
      <Form
        {...props}
        style={styles.forElement("form", { backgroundColor: "#F4F6F9" })}
      >
        <div className="formkit-container" data-stacked={stackedDisplay}>
          <Elements.Content
            name="content"
            defaults={{
              content: "Get your free t-shirt by signing up."
            }}
          />

          <div style={{ color: contentColor }}>
            <Elements.Errors />

            <Elements.CustomFields
              style={{ color: contentColor }}
              direction={stackedDisplay ? "vertical" : "horizontal"}
            >
              <Elements.Button
                name="submit"
                group="button"
                defaults={{ content: "Sign up" }}
              />
            </Elements.CustomFields>
          </div>
        </div>
        <Elements.AddFieldButton />
      </Form>
    )
  }
}

Grove.displayName = "Grove"

export default Grove
